<div class="carousel-container">
  @if (chartAvailable(slideDirections.PREV)) {
    <div
      class="arrow-container arrow-container--left"
      (click)="changeChart(slideDirections.PREV)"
      data-cy="chart-carousel-arrow-left"
      (keydown.space)="changeChart(slideDirections.PREV)"
      (keydown.enter)="changeChart(slideDirections.PREV)"
      tabindex="0"
      >
      <svg-icon src="assets/icons/chart-arrow.svg" [svgStyle]="{ 'width.px':47 }"></svg-icon>
    </div>
  }

  @if (instrumentChart) {
    <div class="chart-container">
      @if (selectedChart === charTypes.INSTRUMENTS) {
        <div>
          <libero-instrument-chart-card [cardData]="instrumentChart"></libero-instrument-chart-card>
        </div>
      }
      @if (selectedChart === charTypes.REGION) {
        <div>
          <libero-region-chart-card [cardData]="instrumentChart"></libero-region-chart-card>
        </div>
      }
      @if (selectedChart === charTypes.HISTORY) {
        <div>
          <libero-history-chart-card [cardData]="instrumentChart" [userLocalization]="userLocalization"></libero-history-chart-card>
        </div>
      }
    </div>
  }
  @if (chartAvailable(slideDirections.NEXT)) {
    <div
      class="arrow-container arrow-container--right"
      (click)="changeChart(slideDirections.NEXT)"
      data-cy="chart-carousel-arrow-right"
      (keydown.space)="changeChart(slideDirections.NEXT)"
      (keydown.enter)="changeChart(slideDirections.NEXT)"
      tabindex="0"
      >
      <svg-icon src="assets/icons/chart-arrow.svg" [svgStyle]="{ 'width.px':47, 'transform': 'rotate(180deg)' }"></svg-icon>
    </div>
  }

  @if (chartAvailable(slideDirections.NEXT) || chartAvailable(slideDirections.PREV)) {
    <div class="pagination-container">
      <div
        class="page-bullet"
        [ngClass]="{ 'page-bullet--active': selectedChart === charTypes.INSTRUMENTS }"
        (click)="changeChart(charTypes.INSTRUMENTS)"
        (keydown.space)="changeChart(charTypes.INSTRUMENTS)"
        (keydown.enter)="changeChart(charTypes.INSTRUMENTS)"
        tabindex="0"
      ></div>
      <div
        class="page-bullet"
        [ngClass]="{ 'page-bullet--active': selectedChart === charTypes.REGION }"
        (click)="changeChart(charTypes.REGION)"
        (keydown.space)="changeChart(charTypes.REGION)"
        (keydown.enter)="changeChart(charTypes.REGION)"
        tabindex="0"
      ></div>
      <div
        class="page-bullet"
        [ngClass]="{ 'page-bullet--active': selectedChart === charTypes.HISTORY }"
        (click)="changeChart(charTypes.HISTORY)"
        data-cy="instruments-history-page-bullet"
        (keydown.space)="changeChart(charTypes.HISTORY)"
        (keydown.enter)="changeChart(charTypes.HISTORY)"
        tabindex="0"
      ></div>
    </div>
  }
</div>
